module.exports = __webpack_public_path__ + "img/t4-m11.5148e680.png";